module.exports = new __parcel__URL__("insight-object-schema-details-skeleton.tpl.37ee765d.svg").toString();